import { render, staticRenderFns } from "./PlaqueWork.vue?vue&type=template&id=a6cabdbc&scoped=true"
import script from "./PlaqueWork.vue?vue&type=script&lang=js"
export * from "./PlaqueWork.vue?vue&type=script&lang=js"
import style0 from "./PlaqueWork.vue?vue&type=style&index=0&id=a6cabdbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cabdbc",
  null
  
)

export default component.exports